import {
    Dic
} from '$utils'
export const tableOption = function () {
    return {
        add: '新增',
        edit: '修改',
        view: '详情',
        page: true,
        selection: false,
        index: false,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewFormSlot: true,
        labelSuffix: '：',
        align: 'left',
        size: 'small',
        maxHeight: '100%',
        labelWidth: '110px',
        labelPosition: 'right',
        menuAlign: 'center',
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 350,
        dialogWidth: '700px',
        emptyText: '暂无数据',
        menu: false,
        column: [{
                label: '记录编号',
                prop: 'recordCode',
                search: false,
                hide: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                span: 12,
                align: 'center',
            },
            {
                label: '操作时间',
                prop: 'operateTime',
                search: true,
                hide: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                searchSlot: true,
                span: 12,
                align: 'center',
                type: 'datetimerange'
            },
            {
                label: '操作类型',
                prop: 'operateType',
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                span: 12,
                align: 'center',
                dicData: Dic.find('SENU099001'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU099001', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU099001', value) : ''
                },
                // formatter: function (row, value) {
                //   if (value == 1) {
                //     return "单键操作"
                //   } else {
                //     return "一键操作"
                //   }
                // },
            },
            {
                label: '操作账号',
                prop: 'operator',
                search: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
                span: 12,
            },
            {
                label: '操作姓名',
                prop: 'operatorName',
                search: true,
                clearable: true,
                hide: false,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                span: 12,
            },
            {
                label: '主机名称',
                prop: 'deviceName',
                search: true,
                clearable: true,
                searchSlot: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
                span: 24,
            },
            {
                label: '主机ID',
                prop: 'thirdDeviceId',
                search: true,
                clearable: true,
                overHidden: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                align: 'right',
                span: 12,
            },
            {
                label: '消防设备类型',
                prop: 'deviceMark',
                search: false,
                overHidden: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                align: 'right',
                type: 'select',
                span: 12,
                dicData: Dic.find('SENU087'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU087', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU087', value) : ''
                },
            },
            {
                label: '部件名称',
                prop: 'subDeviceName',
                search: false,
                clearable: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
                span: 12,
            },
            // {
            //     label: '部件编号',
            //     prop: 'componentThirdDeviceId',
            //     search: false,
            //     clearable: true,
            //     addDisplay: false,
            //     editDisplay: false,
            //     viewDisplay: true,
            //     editDisabled: false,
            //     overHidden: true,
            //     align: 'center',
            //     span: 12,
            // },
            {
                label: '唯一标识号',
                prop: 'subThirdDeviceId',
                search: false,
                clearable: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                editDisabled: false,
                overHidden: true,
                align: 'center',
                span: 12,
            },
            {
                label: '部件类型',
                prop: 'subDeviceMark',
                search: false,
                overHidden: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                align: 'right',
                type: 'select',
                span: 12,
                dicData: Dic.find('SENU094'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU094', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU094', value) : ''
                },
            },
            {
                label: '消防型号',
                prop: 'deviceVersion',
                search: false,
                overHidden: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                align: 'right',
                type: 'select',
                span: 12,
                dicData: Dic.find('SENU095'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU095', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU095', value) : ''
                },
            },
            {
                label: '回执结果',
                prop: 'replySign',
                search: false,
                overHidden: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                align: 'right',
                type: 'select',
                span: 12,
                dicData: Dic.find('SENU096'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU096', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU096', value) : ''
                },
            },
            // {
            //     label: '回执时间',
            //     prop: 'replyTime',
            //     search: false,
            //     overHidden: true,
            //     addDisplay: false,
            //     editDisplay: false,
            //     viewDisplay: true,
            //     align: 'right',
            //     span: 12,
            // },
            // {
            //     label: '控制器编号',
            //     prop: 'controlCodeStr',
            //     search: false,
            //     overHidden: true,
            //     addDisplay: false,
            //     editDisplay: false,
            //     viewDisplay: true,
            //     align: 'right',
            //     span: 12,
            // },
            {
                label: '内容',
                prop: 'cmdKeyName',
                search: false,
                overHidden: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: true,
                align: 'right',
                span: 24,
            },
        ]
    }
}